module.exports = __webpack_public_path__ + "static/img/logo_36.d348ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_36.png
// module id = Ix4D
// module chunks = 1